import { Strings } from './strings';

class Paths {
  static join(base: string, other: string): string {
    if (!base) {
      return other;
    }
    return (
      Strings.ensureTrailingSlash(base) + Strings.removeLeadingSlash(other)
    );
  }
}

export default Paths;
